import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useThemeColor } from "./useThemeColor.js";
const RemoveCircleIcon = forwardRef(
  ({ backgroundColor: propBackgroundColor = "transparent", ...props }, ref) => {
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 13379", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Path 14347",
          d: "M7.5 0A7.5 7.5 0 1 0 15 7.5 7.509 7.509 0 0 0 7.5 0z",
          fill: backgroundColor
        }
      ),
      /* @__PURE__ */ jsx("g", { "data-name": "Group 13365", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 13368", children: /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Line 804",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.25px",
          d: "M0 0h6",
          transform: "translate(4.5 7.499)"
        }
      ) }) })
    ] }) }) });
  }
);
export {
  RemoveCircleIcon
};
//# sourceMappingURL=RemoveCircleIcon.js.map
